import app, { vuwer } from "@@assets/scripts/common";
import { formImporter } from "@@assets/form";
import formProps from "./_formProps";

const promise = formImporter();

vuwer.add("formSection", {
	selector: "#form_section",
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		await promise;
		
		this.add("fm", {
			...formProps,
			app,
			selector: "#fm",
			ACTION_URL: `${app.config.apipath}/payments`,
		});
		
		// appから直接アクセス可能にする
		app.fm = this.get("fm");
	}
});
